var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2DashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82609 0.632812H12.2981V15.1669H7.82609V0.632812ZM5.59006 5.10486H1.11802V15.1669H5.59006V5.10486ZM20.1242 17.403H0V18.6328H20.1242V17.403ZM19.0062 7.34089H14.5342V15.1669H19.0062V7.34089Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2DashboardWhite);
export default __webpack_public_path__ + "static/media/v2-dashboard-white.202d6a9687b929cac7e6291bb88baaf8.svg";
export { ForwardRef as ReactComponent };